export default function Tours() {
  return <h2>Tours Loaded</h2>;
}
